export default __webpack_public_path__ + "static/media/g102.f6221ea0.svg";